module.exports = __webpack_public_path__ + "img/b0572c4.jpg";